export default {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  tipoAcessoOrigem: {
    value: [],
    options: [
      {name: 'Vendas', value: 'VENDA'},
      {name: 'Operações', value: 'OPERACAO'},
      {name: 'Cobranças', value: 'COBRANCA'}
    ],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/origem/components/add/origin-form.js